import { PaymentMethod } from "common/types";

import DrawerLayout from "client/common/components/stackables/DrawerLayout";
import PaymentForm from "client/payments/components/PaymentForm";
import PrivacyDisclaimerTooltip from "client/common/components/content/PrivacyDisclaimerTooltip";
import { useCurrentDrawer } from "client/common/hooks/stackables";

import { useCreatePaymentMethodMutation } from "../hooks";

export type PaymentCreateDrawerProps = {
  onSuccess: (method: PaymentMethod) => void;
};

const PaymentCreateDrawer = ({ onSuccess }: PaymentCreateDrawerProps) => {
  const { close } = useCurrentDrawer();

  const {
    mutate: createPaymentMethod,
    isLoading: isCreating,
    error: paymentCreateError,
  } = useCreatePaymentMethodMutation({
    onSuccess: (method) => {
      onSuccess(method);
      close();
    },
  });

  return (
    <DrawerLayout>
      <DrawerLayout.Header
        title={<PrivacyDisclaimerTooltip>Add payment method</PrivacyDisclaimerTooltip>}
        description="American Express, Discover &amp; Diners, Mastercard, and Visa"
        onClose={close}
      />
      <PaymentForm
        isLoading={isCreating}
        onSubmit={(id) => createPaymentMethod({ payment_method: id })}
        error={paymentCreateError}
      />
    </DrawerLayout>
  );
};

export default PaymentCreateDrawer;
